"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "argusto": {
    "05f606cd": [{
      "hkey": "1d8d942d",
      "slug": "argusto",
      "name": "Argusto",
      "primary": true,
      "skipSearch": false
    }],
    "fumarica": [{
      "hkey": "1d8d942d",
      "slug": "argusto",
      "name": "Argusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "124b7562": [{
      "hkey": "1d8d942d",
      "slug": "argusto",
      "name": "Argusto",
      "primary": true,
      "skipSearch": false
    }],
    "malvaradi": [{
      "hkey": "1d8d942d",
      "slug": "argusto",
      "name": "Argusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3e0d749": [{
      "hkey": "1d8d942d",
      "slug": "argusto",
      "name": "Argusto",
      "primary": true,
      "skipSearch": false
    }],
    "papara": [{
      "hkey": "1d8d942d",
      "slug": "argusto",
      "name": "Argusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;